import { Box, Button, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MealForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>

      <TextField
        error={Boolean(touched.food && errors.food)}
        fullWidth
        helperText={touched.food && errors.food}
        label="Food"
        margin="normal"
        name="food"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.food}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.quantity && errors.quantity)}
        fullWidth
        helperText={touched.quantity && errors.quantity}
        label="Quantity"
        margin="normal"
        name="quantity"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.quantity}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.time && errors.time)}
        fullWidth
        helperText={touched.time && errors.time}
        label="Time"
        margin="normal"
        name="time"
        onBlur={handleBlur}
        onChange={handleChange}
        type="time"
        value={values.time}
        variant="outlined"
      />

      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default MealForm;
